module.exports = __webpack_public_path__ + "assets/43834807a215e071a4c9f94dddedbcbd.png";